export default __webpack_public_path__ + "static/media/f55ff1ecc56efcc8.b0d99285634194f26f53b4a773a0a507.svg";